<template>
  <div>
    <template v-if="productTemplateDesignId">
      <OverlappedPreview
        :preview-urls="productTemplatePreviewUrls"
        :rounded="productTemplateIsRounded"
        v-on="$listeners"
        :edit-button="editButton"
        class="preview"
        />
    </template>
    <img v-else class="placeholder" src="/static/images/dashboard/placeholder_card.svg">
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ['compact', 'editButton'],
  computed: mapGetters([
    "productTemplateDesignId",
    "productTemplatePreviewUrls",
    "productTemplateIsRounded",
  ]),
};
</script>

<style lang="scss" scoped>
img.placeholder {
  width: 100%;
  max-width: 504px;
}
.preview {
  max-width: 504px;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/ProductTemplatePreview.vue